import { Chart } from "chart.js/auto";
import { Dom } from "./dom";

interface Dimension {
    DataText: string;
    Colors: string[];
    Values: number[];
}

export interface ChartData {
    Labels: string[];
    Dimensions: Dimension[];
    Title: string;
    Doughnut: boolean;
    Line: boolean;
}

export class ChartTableCreator
{
    static createChart(parent, chart: ChartData, IsFullView?: boolean)
    {
        const canvas = Dom.add("canvas", parent[0]);

        const width = IsFullView ? 800 : 400;
        const height = IsFullView ? 550 : 250;

        canvas.setAttribute("width", width.toString());
        canvas.setAttribute("height", height.toString());

        const chartData: any = {
            labels: chart.Labels,
            datasets: []
        };
        for (const dimension of chart.Dimensions)
        {
            const dataset: any = { label: dimension.DataText, data: dimension.Values, backgroundColor: dimension.Colors };
            if (chart.Line)
            {
                dataset.backgroundColor = dimension.Colors[0];
                dataset.borderColor = dimension.Colors[0] + "30";
                dataset.fill = false;
            }
            chartData.datasets.push(dataset);
        }
        const options: any = {
            maintainAspectRatio: false,
            plugins: {}
        };
        if (chart.Title)
        {
            options.plugins.title = {
                display: true,
                text: chart.Title
            };
        }

        new Chart(canvas, {
            type: chart.Doughnut ? "doughnut" : chart.Line ? "line" : "bar",
            data: chartData,
            options: options
        });
    }
}
